import React, { useEffect, useState } from "react";
import api from '../../services/api';
import { useNavigate, useParams } from "react-router-dom";
import ComplainForm from "../../components/ComplainForm";

const CreateComplain = () => {
  const navigate = useNavigate();
  const { applicantId } = useParams();
  const [applicant, setApplicant] = useState(null);
  const token = localStorage.getItem("token"); // Get token from localStorage
  
  
  const [loading, setLoading] = useState(false);

useEffect(() => {
  const fetchApplicant = async () => {
    if (!applicantId) {
      console.error("applicantId is undefined");
      return;
    }

    setLoading(true);
    try {
      const response = await api.get(`/applicants/${applicantId}`);
      setApplicant(response.data);
    } catch (error) {
      console.error("Error fetching applicant:", {
        message: error.message,
        status: error.response?.status,
        responseData: error.response?.data
      });
    } finally {
      setLoading(false);
    }
  };

  fetchApplicant();
}, [applicantId]); // token removed from dependencies since interceptor handles it

const handleSubmit = async (data) => {
  try {
    // Make the POST request using your api instance
    await api.post('/Complains', {
      ...data,
      applicantID: applicantId
    });
    
    // Navigate on success
    navigate("/complains/complainlist");
    
  } catch (error) {
    // Enhanced error handling
    const errorMessage = error.response?.data?.message || error.message || 'Failed to submit complaint';
    
    console.error("Error submitting complaint:", {
      error: error.response?.data || error.message,
      status: error.response?.status
    });
  }
};

  return (
    <div className="container mx-auto p-4">
      {applicant ? (
        <ComplainForm onSubmit={handleSubmit} defaultValues={{}} applicant={applicant} />
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default CreateComplain;
